module.exports = __webpack_public_path__ + "static/media/board-of-nursing.0ef6b821.png";